// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as PlaceOrderAssetsManager from "../../assets/PlaceOrderAssetsManager.bs.js";

var errorBanner = PlaceOrderAssetsManager.getImage("error-banner.svg");

function ErrorVehicleSelectionSectionCmp(Props) {
  var onRefreshList = Props.onRefreshList;
  return React.createElement("div", {
              className: "section__container"
            }, React.createElement("span", {
                  className: "title"
                }, "VEHICLE SELECTION"), React.createElement("div", {
                  className: "empty-vehicle-section__container"
                }, React.createElement("img", {
                      className: "error-banner__img",
                      alt: "Something happened while loading the vehicles",
                      src: errorBanner
                    }), React.createElement("div", {
                      className: "error-message__container"
                    }, React.createElement("p", {
                          className: "title"
                        }, "Something happened while loading vehicles"), React.createElement("div", {
                          className: "row"
                        }, React.createElement("button", {
                              className: "refresh-button",
                              onClick: (function (param) {
                                  return Curry._1(onRefreshList, undefined);
                                })
                            }, React.createElement("p", {
                                  className: "sub-text"
                                }, "Refresh now")), React.createElement("p", {
                              className: "sub-text"
                            }, " to load the list again")))));
}

var make = ErrorVehicleSelectionSectionCmp;

export {
  errorBanner ,
  make ,
  
}
/* errorBanner Not a pure module */
